import win from '../win'

const logger = store => next => action => {
  if (!win.PRODUCTION) {
    console.group(!action.type ? 'ASYNC_ACTION' : action.type)
    console.info('dispatching', action)
    const result = next(action)
    console.log('next state', store.getState())
    console.groupEnd()
    return result
  }

  return next(action)
}

export default logger
